/* GASSISA
=========================================================================================
* Descripcion: Formulario de preventas independiente para dispositivos portatiles.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
*      2       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Ajuste de distribucion visual portatil
*      3       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Implementacion autonoma con modales portatiles
 *      4       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Estado compartido para buscador de articulos
 *      5       | 30/08/2026 | Lic. Jose Luis Aragon Cervantes  | Alt+F12 elimina preventa con confirmacion
 *      6       | 08/10/2026 | LIC. José Luis Aragón C.                       | Icono camara junto al lector manual
 *              |            |                                  | (abre/cierra escaner iOS/Android)
 * ---------------------------------------------------------------------------------------
 */

import { Fragment, useEffect, useRef, useState } from "react";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

import { useSesion } from "../../../context/System/SesionContext";
import { useVentas } from "../../../context/Ventas/VentasContext";
import { useFormTabLock } from "../../../hooks/useFormTabLock";

import SizeSoftXFrmPortatil from "../leyout/SizeSoftXFrmPortatil.jsx";
import SizeSoftXLectorCodigoBarrasPortatil from "../leyout/SizeSoftXLectorCodigoBarrasPortatil.jsx";
import SizeSoftXCodigoBarrasCamaraPortatil from "../leyout/SizeSoftXCodigoBarrasCamaraPortatil.jsx";
import SizeSoftXTableVentas from "../../leyout/SizeSoftXTableVentas";
import SizeSoftXDetallesVentas from "../../leyout/SizeSoftXDetallesVentas";
import SizeSoftXVentasLayout from "../../leyout/SizeSoftXVentasLayout";
import SizeSoftXAlert from "../../utils/SizeSoftXAlert";
import SizeSoftXConfirmDialog from "../../leyout/SizeSoftXConfirmDialog";

import MnuPreVentasActionsPortatil from "./MnuPreVentasActionsPortatil.jsx";
import MnuOtherActionsPreventasPortatil from "./MnuOtherActionsPreventasPortatil.jsx";
import ModalEditarPartidasVentasPortatil from "../modales/ModalEditarPartidasVentasPortatil.jsx";
import ModalBuscarArticulosParaVentaPortatil from "../modales/ModalBuscarArticulosParaVentaPortatil.jsx";
import ModalFirmarVentasPortatil from "../modales/ModalFirmarVentasPortatil.jsx";
import ModalJalarPreventasCotizacionesPortatil from "../modales/ModalJalarPreventasCotizacionesPortatil.jsx";
import ModalRecuperarPreventasPortatil from "../modales/ModalRecuperarPreventasPortatil.jsx";
import ModalBuscarClientesPortatil from "../modales/ModalBuscarClientesPortatil.jsx";

export default function FrmPreventasPortatil() {
  const { isLocked: isFormLocked } = useFormTabLock("preventas", { title: "Preventas" });
  const lectorCodigoBarrasRef = useRef(null);
  const camaraCodigoBarrasRef = useRef(null);
  const { usuarioData, parametrosCajaForm, handleObtenerParametrosCaja } = useSesion();
  const [usuarioFirmante, setUsuarioFirmante] = useState("");
  const [openModalFirmaJalarPreventaCotizaciones, setOpenModalFirmaJalarPreventaCotizaciones] = useState(false);
  const [openConfirmEliminarPreventa, setOpenConfirmEliminarPreventa] = useState(false);

  const {
    listaPreventaTemporal,
    partidaSeleccionadaPreventas,
    handleChangePartidaSeleccionadaPreventas,
    handleClickEditarPartidaPreventas,
    handleCerrarModalEditarPartidas,
    handleClickRefrescarDatosPreVenta,
    handleRetotalizarCuentaVenta,
    handleBuscarClienteFromClave,
    openModalPartidas,
    clienteForm,
    ventaTotales,
    handleRegistrarArticuloSubmitPreVenta,
    handleSumarPartidaPreVentas,
    handleRestarPartidaPreVentas,
    handleCambioTipoVenta,
    handleClickEliminarPartidaVentas,
    openModalFirma,
    handleCerrarModalFirmaPreVenta,
    handleFirmarPreventa,
    handleCerrarModalJalarPreVentaCotizacion,
    handleInyectarPreventaCotizacionAVenta,
    openModalJalarPreventaCotizacion,
    handleCerrarModalRecuperarPreVenta,
    handleRecuperarPreventas,
    openModalRecuperarPreventa,
    handleAbrirModalRecuperarPreVenta,
    handleCerrarModalRecuperarPreVentaFirma,
    openModalRecuperarPreventaFirma,
    handleClickRegresarMainDashboard,
    handleArirModalFirmaPreVenta,
    handleAbrirModalRecuperarPreVentaFirma,
    handleBuscarArticulos,
    handleCloseModalBuscarArticulosPreventas,
    handleArirModalBuscarArticulosPreventas,
    handleClickEliminarPreVenta,
    setVentaTotales,
    getVentaTotalesForm,
    setClienteForm,
    handleClickEliminarPartidaPreVentas,
    handleArirModalBuscarCliente,
    handleCerrarModalBuscarCliente,
    openModalBuscarCliente,
    mostrarBuscadorArticulos,
    setMostrarBuscadorArticulos,
  } = useVentas();

  const enfocarFiltroArticulos = () => {
    setTimeout(() => {
      const filtroInput = document.querySelector('.modal-buscador-articulos-portatil input[name="Filtro"]');
      filtroInput?.focus?.({ preventScroll: true });
      filtroInput?.select?.();
    }, 120);
  };

  const abrirBuscadorArticulos = () => {
    setMostrarBuscadorArticulos(true);
    handleArirModalBuscarArticulosPreventas();
    enfocarFiltroArticulos();
  };

  const cerrarBuscadorArticulos = () => {
    setMostrarBuscadorArticulos(false);
    handleCloseModalBuscarArticulosPreventas();
  };

  const enfocarLectorDespuesRegistro = () => {
    setTimeout(() => lectorCodigoBarrasRef.current?.focusAndSelect?.(), 120);
  };

  const handleRegistrarArticuloCodigoBarras = async (data, almacenExhibidor) => {
    setMostrarBuscadorArticulos(false);
    await handleRegistrarArticuloSubmitPreVenta(data.codigobarras, almacenExhibidor);
    handleCloseModalBuscarArticulosPreventas();
    enfocarLectorDespuesRegistro();
  };

  const handleFirmarPreventaLista = (vendedorNombre) => {
    if (!vendedorNombre) return;
    const nombre = String(vendedorNombre);
    setUsuarioFirmante(nombre);
    handleFirmarPreventa(parametrosCajaForm.foliopreventa, nombre);
  };

  const handleCargarVendedorPreventasLista = (vendedorNombre) => {
    if (!vendedorNombre) return;
    setUsuarioFirmante(String(vendedorNombre));
    setOpenModalFirmaJalarPreventaCotizaciones(true);
  };

  const handleAbrirModalRecuperacion = (nombreVendedor) => {
    setUsuarioFirmante(nombreVendedor);
    handleAbrirModalRecuperarPreVenta();
  };

  const clickEliminarPreVenta = () => {
    handleClickEliminarPreVenta();
    setVentaTotales(getVentaTotalesForm());
    setClienteForm({});
  };

  useEffect(() => {
    if (!parametrosCajaForm.caja || parametrosCajaForm.caja === "CAJA-DEFAULT") {
      handleObtenerParametrosCaja();
    }
    handleCambioTipoVenta("PREVENTA");
    handleClickRefrescarDatosPreVenta();
  }, []);

  useEffect(() => {
    if (!isFormLocked) return;
    alert("El formulario de Preventas ya está abierto en otra pestaña del navegador.\n\nCierre la otra ventana para continuar.");
    setTimeout(handleClickRegresarMainDashboard, 900);
  }, [isFormLocked]);

  useEffect(() => {
    handleRetotalizarCuentaVenta(listaPreventaTemporal);
  }, [listaPreventaTemporal]);

  useEffect(() => {
    handleCambioTipoVenta("PREVENTA");
    handleClickRefrescarDatosPreVenta();
  }, [parametrosCajaForm.foliopreventa]);

  useEffect(() => {
    const onKeyDown = (event) => {
      const key = event.key.trim().toUpperCase();
      if (key === "F4") {
        event.preventDefault();
        handleClickRegresarMainDashboard();
      } else if (event.altKey && key === "F10" && listaPreventaTemporal.length > 0) {
        event.preventDefault();
        handleArirModalFirmaPreVenta();
      } else if (event.altKey && key === "F2") {
        event.preventDefault();
        handleArirModalBuscarCliente();
      } else if (event.altKey && key === "F1") {
        event.preventDefault();
        abrirBuscadorArticulos();
      } else if (event.altKey && key === "F12") {
        event.preventDefault();
        setOpenConfirmEliminarPreventa(true);
      } else if (event.altKey && key === "F7") {
        event.preventDefault();
        handleClickEliminarPartidaPreVentas(partidaSeleccionadaPreventas?.idpartida);
      } else if (event.altKey && key === "J") {
        event.preventDefault();
        handleAbrirModalRecuperarPreVentaFirma();
      }
    };

    window.addEventListener("keydown", onKeyDown, true);
    return () => window.removeEventListener("keydown", onKeyDown, true);
  }, [listaPreventaTemporal.length, partidaSeleccionadaPreventas?.idpartida]);

  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmPreventas">
      <Fragment>
        <SizeSoftXVentasLayout
          titlePage="Modulo de preventas"
          buttonActions={<MnuPreVentasActionsPortatil onBuscarArticulos={abrirBuscadorArticulos} />}
          detailComponent={null}
        >
          <div className="title-page venta-header-card preventas-portatil__header">
            <div><small>CAJA</small><strong>{parametrosCajaForm.caja}</strong></div>
            <div><small>TICKET</small><strong>{parametrosCajaForm.foliopreventa}</strong></div>
            <div><small>ATIENDE</small><strong>{usuarioData.Usuario}</strong><span>{usuarioData.Nombre}</span></div>
            <div><small>CLIENTE</small><strong>{clienteForm.clavecliente ? `${clienteForm.clavecliente} - ` : ""}{clienteForm.razonsocial || "Sin cliente"}</strong></div>
            <div><small>DESCUENTO</small><strong>{clienteForm.porcentajedescuento || 0}%</strong></div>
            <div><small>CONTACTO</small><strong>{clienteForm.contacto || "-"}</strong></div>
          </div>

          <div className="venta-super-container venta-super-container-preventas">
            <div className="venta-super-left-preventas">
              <SizeSoftXTableVentas
                columns={[
                  {
                    hideSort: false,
                    field: "editrow",
                    render: () => (
                      <IconButton onClick={handleClickEditarPartidaPreventas}>
                        <EditIcon color="primary" />
                      </IconButton>
                    ),
                  },
                  { title: "Partida", field: "idpartida" },
                  { title: "Clave articulo", field: "clavearticulo" },
                  { title: "Descripcion", field: "descripcion" },
                  { title: "Medida", field: "medida" },
                  { title: "Cantidad", field: "cantidad" },
                  { title: "Costo unitario", field: "costounitario" },
                  { title: "Costo cliente", field: "costocliente" },
                  { title: "Descuento", field: "descuento" },
                  { title: "Subtotal", field: "subtotal" },
                  { title: "IVA", field: "iva" },
                  { title: "Total", field: "total" },
                  { title: "Origen", field: "almacenexhibidor" },
                  { title: "Folio preventa", field: "foliopreventa" },
                  { title: "Vendedor", field: "vendedorpreventa" },
                ]}
                data={listaPreventaTemporal ?? []}
                id="idpartida"
                row={partidaSeleccionadaPreventas}
                setRow={handleChangePartidaSeleccionadaPreventas}
                fnDoubleClick={handleClickEditarPartidaPreventas}
                fontSize="small"
                rowsPerPageIntro={50}
              />
            </div>

            <div className="venta-frame-right-preventas">
              <div className="venta-super-right-preventas">
                <div className="framelectorcodigosbarras">
                  <SizeSoftXLectorCodigoBarrasPortatil
                    ref={lectorCodigoBarrasRef}
                    TipoVenta="PREVENTA"
                    mostrarBotonCamara
                    onAbrirCamara={() => camaraCodigoBarrasRef.current?.toggleCamara?.()}
                  />
                  <SizeSoftXCodigoBarrasCamaraPortatil ref={camaraCodigoBarrasRef} TipoVenta="PREVENTA" />
                </div>
                <SizeSoftXDetallesVentas ventasTotales={ventaTotales} />
              </div>
            </div>
          </div>

          <ModalBuscarArticulosParaVentaPortatil
            openModal={mostrarBuscadorArticulos}
            handleCloseModal={cerrarBuscadorArticulos}
            handleCargarArticulo={handleBuscarArticulos}
            dominio={parametrosCajaForm.dominio}
            consultarTodosAlmacenes
            skipFullData={true}
            onTallaSelect={() => {}}
            articuloSelect={handleRegistrarArticuloCodigoBarras}
          />

          <ModalEditarPartidasVentasPortatil
            openModal={openModalPartidas}
            rowSelect={partidaSeleccionadaPreventas}
            handleClose={handleCerrarModalEditarPartidas}
            handleEliminar={() => {
              handleClickEliminarPartidaPreVentas(partidaSeleccionadaPreventas?.idpartida);
              handleCerrarModalEditarPartidas();
            }}
            handleSubmitEditarPartidaVentaSumar={handleSumarPartidaPreVentas}
            handleSubmitEditarPartidaVentaRestar={handleRestarPartidaPreVentas}
          />

          <ModalFirmarVentasPortatil
            openModalFirmaPreVentas={openModalFirma}
            handleCloseModalFirmaPreVentas={handleCerrarModalFirmaPreVenta}
            handleFirmarPreventa={handleFirmarPreventaLista}
          />

          <ModalFirmarVentasPortatil
            openModalFirmaPreVentas={openModalFirmaJalarPreventaCotizaciones}
            handleCloseModalFirmaPreVentas={() => setOpenModalFirmaJalarPreventaCotizaciones(false)}
            handleFirmarPreventa={handleCargarVendedorPreventasLista}
          />

          <ModalJalarPreventasCotizacionesPortatil
            openModalJalarPreventaCotizacion={openModalJalarPreventaCotizacion}
            handleCloseModalJalarPreventaCotizacion={handleCerrarModalJalarPreVentaCotizacion}
            handleJalarPreventaCotizacion={() => handleInyectarPreventaCotizacionAVenta("PREVENTA")}
            vendedor={usuarioData.Usuario}
          />

          <ModalRecuperarPreventasPortatil
            openModalRecuperarPreventas={openModalRecuperarPreventa}
            handleCloseModalRecuperarPreventas={handleCerrarModalRecuperarPreVenta}
            handleRecuperarPreventas={handleRecuperarPreventas}
            vendedor={String(usuarioFirmante)}
          />

          <ModalFirmarVentasPortatil
            openModalFirmaPreVentas={openModalRecuperarPreventaFirma}
            handleCloseModalFirmaPreVentas={handleCerrarModalRecuperarPreVentaFirma}
            handleFirmarPreventa={handleAbrirModalRecuperacion}
          />

          <ModalBuscarClientesPortatil
            openModal={openModalBuscarCliente}
            handleCloseModal={handleCerrarModalBuscarCliente}
            onClienteSelect={async (cliente) => {
              await handleBuscarClienteFromClave(cliente.clavecliente);
              handleCerrarModalBuscarCliente();
            }}
          />

          <SizeSoftXConfirmDialog
            open={openConfirmEliminarPreventa}
            title="Eliminar preventa"
            message="¿Desea eliminar toda la preventa actual?"
            handleConfirmDialog={(confirm) => {
              setOpenConfirmEliminarPreventa(false);
              if (confirm) clickEliminarPreVenta();
            }}
          />
          <SizeSoftXAlert />
          <MnuOtherActionsPreventasPortatil />
        </SizeSoftXVentasLayout>
      </Fragment>
    </SizeSoftXFrmPortatil>
  );
}
